import { axiosClient } from "@/lib/axios";
import { HttpError } from "@/types/error";
import { Me } from "@classview/shared-types";
import { UseQueryOptions, useQuery } from "@tanstack/react-query";

const getMyOrganisations = async (): Promise<Me> => {
  const response = await axiosClient.get(`/users/me`);
  return response.data;
};

export function getMyOrganisationsQueryKey() {
  return ["me"];
}

export function useMe(queryOptions?: UseQueryOptions<Me, HttpError>) {
  return useQuery({
    queryKey: getMyOrganisationsQueryKey(),
    queryFn: getMyOrganisations,
    staleTime: 30 * 60 * 1000, // 30 minutes
    ...queryOptions,
  });
}
